module.exports = __webpack_public_path__ + "media/images/story/icon/calendar-d9b56384b94c83d83b74cd1ee03233e9.svg";